"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _OneMediaCenterBottomTextLayout = require("./OneMediaCenterBottomTextLayout");
Object.keys(_OneMediaCenterBottomTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _OneMediaCenterBottomTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _OneMediaCenterBottomTextLayout[key];
        }
    });
});
